/* SERYN - texto mais curto e direto no banner de cookies nativo do Shopify (botões e lógica continuam do Shopify) */
(function () {
  'use strict';
  var TITLE = 'Cookies';
  var TEXT = 'Usamos cookies para melhorar sua experiência e medir nossos anúncios.';

  function patch() {
    var title = document.getElementById('shopify-pc__banner__body-title');
    var link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (!title || !link) return false;
    var p = link.closest('p');
    if (!p || p.getAttribute('data-seryn') === '1') return true;
    title.textContent = TITLE;
    while (p.firstChild) p.removeChild(p.firstChild);
    p.appendChild(document.createTextNode(TEXT + ' '));
    p.appendChild(link);
    p.setAttribute('data-seryn', '1');
    return true;
  }

  function watch() {
    patch();
    /* O Shopify pode redesenhar o banner, então continuamos aplicando por um tempo */
    var mo = new MutationObserver(function () { patch(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 60000);
  }

  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
